import { graphql } from 'react-relay/legacy.js';

export type {
    pdpRespMarketplacePrimaryRootQuery$variables,
    pdpRespMarketplacePrimaryRootQuery as PdpRespMarketplacePrimaryRootQueryType,
} from './__generated__/pdpRespMarketplacePrimaryRootQuery.graphql.ts';

export const pdpRespMarketplacePrimaryRootQuery = graphql`
    query pdpRespMarketplacePrimaryRootQuery(
        $itemId: String!
        $itemIds: [String]!
        $userIds: [String]!
        $userId: String = ""
        $userZipCode: String = ""
        $isTrade: Boolean = false
        $forcedCurrency: Currency
        $fetchPdp: Boolean = false
        $fetchUser: Boolean = false
        $priceBookName: String = ""
        $isMultiSku: Boolean = false
        $userCountryCode: String = ""
        $afterDisplay: Boolean = false
        $personalizationId: String = ""
        $afterDisplayOrBtSsr: Boolean = false
        $isInteractivePdpChat: Boolean = false
        $isPdpImageGalleryRedesignVariant: Boolean = false
        $isPdpSimilarSoldItemsModuleVariant: Boolean = false
        $similarItemsCount: Int!
        $isEstimateSimilarSoldVariant: Boolean = false
        $isPdpSellerModuleTestVariant: Boolean = false
    ) {
        viewer {
            ...PdpHeadBuilder_viewer
            ...PdpRespMarketplaceLayoutPrimary_viewer
            # eslint-disable-next-line relay/unused-fields
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    ...PdpHeadBuilder_item
                    ...handlePdpStatuses_item @skip(if: $afterDisplay)
                }
                ...findPdpItemReadError_itemRead
            }
        }
    }
`;
